import { GET_METER_CORE, CREATE_METER_CORE, GET_METERS_LIST, PROCESS_METER_PAYMENT_CORE, CREATE_PROCESS_METER_CODE} from './../constants';
import { handleActions } from "redux-actions"

export const metersCore  = handleActions(
  { 
    [ GET_METER_CORE ]: (state, action) => state,
    [CREATE_METER_CORE]: (state, action) => [...state, action.payload.data],
    [ GET_METERS_LIST]: (state, action) => action.payload,
    [ PROCESS_METER_PAYMENT_CORE]: (state, action) => state,
    [ CREATE_PROCESS_METER_CODE ]: (state, action) => state
  }, []
)